import { useState, useRef, useEffect } from "react";
import { useGameContext } from '../GameContext';
import { QuestionTypes, QuestionTypesColor } from "../../utils/types";
import "./SpinnerComponent.css";

import { ANIMATIONS } from "../../utils/constants";
import soundTrackRanking from "../../assets/audios/SoundTrack.mp3";
import dumRollSound from "../../assets/audios/dumRoll.mp3";
import QuestionTextContainer from "../QuestionComponent/QuestionTextContainer/QuestionTextContainer";
import Modal from "../modal/modal";


const SpinnerComponent = ({ playAnimation }) => {
  const { user, game, socket, room } = useGameContext();
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const audioRef = useRef(null); // Referencia para el audio

  useEffect(() => {
    const savedMuted = localStorage.getItem("isMuted");
    const isMutedFromStorage = savedMuted === "true";

    if (audioRef.current) {
      audioRef.current.muted = isMutedFromStorage;
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "isMuted" && audioRef.current) {
        audioRef.current.muted = event.newValue === "true";
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);


  const playSoundDum = () => {
    const sound = new Audio(dumRollSound);
    sound.play();
  };

  const validateInitGame = () => {
    const inRoundCount = game.previousStates.filter(state => state === 'in_round').length;

    if (inRoundCount === 0) {
      return "¡Es hora de comenzar!";
    } else {
      return "¡Es hora de la próxima ronda!";
    }
  }
  //frases para decir el tipo de la nueva pregunta
  const phrases = [
    ["", 1],
    [validateInitGame(), 4, ANIMATIONS.reading],
    ["Nuestro próximo desafío será del tipo", 4, ANIMATIONS.reading],
    [NextQuestionType(), 2.5, ANIMATIONS.reading],
  ]

  //frases para decir al momento de salir el joker
  const phrasesJoker = [
    ["", 0.1],
    ["", .1, ANIMATIONS.talking],
    // ["Ahora elegiremos un viajero al azar para que escoja la siguiente pregunta", 4, ANIMATIONS.talking],
    [(game.currentPlayerJoker === user ? "¿Qué tipo de desafío eliges para la siguiente ronda?" : "Otro viajero está eligiendo cuál será nuestro próximo desafío."), 2.5, ANIMATIONS.talking],
  ]

  function nextLine(phraseIndex) {
    const initialPhrase = !game.applyJoker ? phrases : phrasesJoker;

    if (phraseIndex >= initialPhrase.length - 1) {
      return;
    }

    const newPhrase = phraseIndex + 1;
    const delayInSeconds = initialPhrase[newPhrase][1];

    setCurrentPhrase(newPhrase);
    playAnimation(initialPhrase[newPhrase][2]);

    // Si el nuevo mensaje es "Nuestra proxima pregunta sera del tipo..", baja el volumen y luego ejecuta playSoundDum
    if (initialPhrase[newPhrase][0] === "¡Es hora de la próxima ronda!") {
      fadeOutAudio(audioRef.current, () => {
        playSoundDum();
      });
    }

    setTimeout(() => nextLine(newPhrase), delayInSeconds * 1000);
  }

  function fadeOutAudio(audioElement, callback) {
    if (!audioElement) return;

    let volume = audioElement.volume;
    const fadeInterval = setInterval(() => {
      if (volume > 0.05) {
        volume -= 0.05;
        audioElement.volume = volume;
      } else {
        clearInterval(fadeInterval);
        audioElement.pause();
        audioElement.volume = 1; // Reinicia el volumen para la próxima vez
        if (callback) callback();
      }
    }, 200); // Reducir volumen cada 200ms
  }
  const t = useRef(null);

  useEffect(() => {
    if (t.current) return;

    const initialPhrase = !game.applyJoker ? phrases : phrasesJoker;

    // Start after a delay that gives the first phrase extra time.
    playAnimation(initialPhrase[0][2]);
    const initialDelay = initialPhrase[0][1] * 1000;
    t.current = setTimeout(() => {
      nextLine(0);
    }, initialDelay);
  }, []);


  function NextQuestionType() {
    if (game.current_question) {
      switch (game.current_question.cardType) {
        case QuestionTypes.CONOCIMIENTO:
          return "¡Desafío de Conocimiento!";
        case QuestionTypes.CREATIVIDAD:
          return "¡Desafío Creativo!";
        case QuestionTypes.TALENTO:
          return "¡Desafío de Talento!";
        default:
          return "¡Sorpresa!"
      }
    }
    else {
      return "¡Ups! No hay desafíos disponibles"
    }
  }

  function handleSelectQuestionType(type) {
    setIsButtonDisabled(true);
    socket.emit("selectQuestionType", { questionTypes: type, gameKey: game.id });
  }

  const borderColor = game.current_question && currentPhrase === phrases.length - 1
    ? getBorderColorByCardType(game.current_question.cardType)
    : ''; // Fallback a color transparente si no es el último mensaje

  function getBorderColorByCardType(cardType) {
    switch (cardType) {
      case QuestionTypes.CONOCIMIENTO:
        return QuestionTypesColor.CONOCIMIENTO; // Elige el color que prefieras
      case QuestionTypes.CREATIVIDAD:
        return QuestionTypesColor.CREATIVIDAD;
      case QuestionTypes.TALENTO:
        return QuestionTypesColor.TALENTO;
      default:
        return '';
    }
  }

  if (game.applyJoker) {
    return (
      <>
        <audio ref={audioRef} autoPlay controls loop style={{
          position: 'absolute',
          zIndex: 100,
          opacity: 0
        }}>
          <source src={soundTrackRanking} type="audio/mp3" />
        </audio>
        <Modal show>
          <div className="absolute w-full h-full z-150 top-0 flex flex-col items-center justify-center gap-1">
            <QuestionTextContainer
              text={phrasesJoker[currentPhrase][0]}
              animated
            />
            <div className="joker-container">
              {game.currentPlayerJoker === user && currentPhrase === phrasesJoker.length - 1 ? (
                <div className="joker-selection">
                  <div className="question-type-buttons">
                    {game.applyJokerConocimiento ?
                      <button className="Button"
                        disabled={isButtonDisabled}
                        onClick={() => handleSelectQuestionType(QuestionTypes.CONOCIMIENTO)}><div>Conocimiento</div></button>
                      : null}
                    {game.applyJokerCreatividad ?
                      <button className="Button"
                        disabled={isButtonDisabled}
                        onClick={() => handleSelectQuestionType(QuestionTypes.CREATIVIDAD)}><div>Creatividad</div></button>
                      : null}
                    {game.applyJokerTalento ?
                      <button className="Button"
                        disabled={isButtonDisabled}
                        onClick={() => handleSelectQuestionType(QuestionTypes.TALENTO)}><div>Talento</div></button>
                      : null}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <><audio ref={audioRef} autoPlay controls style={{
      position: 'absolute',
      zIndex: 100,
      opacity: 0
    }}>
      <source src={soundTrackRanking} type="audio/mp3" />
    </audio>
      <Modal show>
        <div className="absolute w-full h-full z-10 top-0 flex flex-col items-center justify-center">
          <QuestionTextContainer text={phrases[currentPhrase][0]} animated />
        </div>
      </Modal>
    </>
  );
};

export default SpinnerComponent;
